import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineSortingIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M11.29 10.21a.9997.9997 0 0 0 1.42 0l3-3a1.0041 1.0041 0 1 0-1.42-1.42L12 8.09l-2.29-2.3a1.0041 1.0041 0 0 0-1.42 1.42l3 3Zm1.42 4.58a.9997.9997 0 0 0-1.42 0l-3 3a1.0041 1.0041 0 0 0 1.42 1.42l2.29-2.3 2.29 2.3a.9997.9997 0 0 0 1.42 0 .9997.9997 0 0 0 0-1.42l-3-3Z"/>
  </SvgIcon>
}

export default LineSortingIcon
